import {
  Stack,
  Breadcrumbs,
  Typography,
  Link,
  Box,
  Container,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import "./SuppliesDetailHeader.scss";
import {
  SuppliesData,
  SuppliesDetailObject,
} from "../../../core/models/suppliesDetail/suppliesDetail.model";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import EnvirormentContent from "../../EnvirormentContent/EnvirormentContent";

interface SuppliesDetailHeaderProps {
  suppliesDetail: SuppliesDetailObject;
  isLoading: boolean;
}

const SuppliesDetailHeader = ({
  suppliesDetail: {
    addressNumber,
    address,
    cupsCode,
    service,
    distributor,
    rate,
    powers,
  },
  isLoading,
}: SuppliesDetailHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParms] = useSearchParams();
  const originPage = searchParms.get("origin") || "";

  const suppliesData: SuppliesData[] = [
    {
      id: "service",
      label: "Servicio",
      value: service,
      renderContent: (service: string) => (
        <EnvirormentContent service={service} variant={"subtitle1"} />
      ),
    },
    {
      id: "distributor",
      label: "Distribuidora",
      value: distributor,
    },
    {
      id: "rate",
      label: "Tarifa",
      value: rate,
    },
  ];

  return (
    <Stack
      direction="column"
      rowGap={{ xs: "24px", md: "40px" }}
      component="article"
      className="supplies-detail-header"
      position="relative"
    >
      {isLoading ? (
        <LoadingComponentComponent isLoading={isLoading} position="absolute" />
      ) : (
        <Container>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              component="button"
              underline="hover"
              onClick={() =>
                navigate(
                  originPage === "bills"
                    ? process.env.REACT_APP_BILLS!
                    : process.env.REACT_APP_SUPPLIES!
                )
              }
            >
              {originPage === "bills"
                ? t("Header.Nav.Facturas")
                : t("Suministros.Suministros")}
            </Link>
            <Typography component="p" variant="caption">
              {`${t("Tablas.CUPS")} ${cupsCode}`}
            </Typography>
          </Breadcrumbs>
          <Stack component="div" paddingBottom="2.5rem" paddingTop="2.5rem">
            <Typography
              component="h1"
              variant="h2"
              className="supplies-detail-header__title"
            >
              {address}, {addressNumber}
            </Typography>
            <Typography
              component="span"
              variant="body2"
              className="supplies-detail-header__label"
            >
              {t("Tablas.CUPS")} {cupsCode}
            </Typography>
          </Stack>
          <Box
            component="div"
            className="supplies-detail-header__supplies-information"
          >
            {suppliesData.map(({ id, label, value, renderContent }) => (
              <Stack key={id} component="div">
                <Typography
                  component="span"
                  variant="body1"
                  className="information-label"
                >
                  {t(`Tablas.${label}`)}
                </Typography>
                {renderContent ? (
                  renderContent(value)
                ) : (
                  <Typography component="span" variant="subtitle1">
                    {value}
                  </Typography>
                )}
              </Stack>
            ))}
            {service.toLowerCase() === 'luz' && [...Array(6).keys()].map((number) => (
              <Stack key={number} component="div">
                <Typography
                  component="span"
                  variant="body1"
                  className="supplies-detail-header__label"
                >
                  {`P${number + 1}`}
                </Typography>
                <Typography component="span" variant="subtitle1">
                  {powers[number]?.hiredPower || "-"} kW
                </Typography>
              </Stack>
            ))}
          </Box>
        </Container>
      )}
    </Stack>
  );
};

export default SuppliesDetailHeader;
